import axios from 'axios';
import CryptoJS from 'crypto-js';
import { Dialog } from 'vant';

// 【纠偏-油脂计划查询】v1 外部接口签名配置：仅用于"司机进错公众号普货对话、实际计划是小程序油脂"的纠偏查询，
// 采用 external-query 签名校验（见《external-query 外部接口签名校验使用文档》），不影响任何既有 /dialog 功能。
const OIL_API_SECRET = 'N8sQ7kDp2zR9bG5vX4tJ1mF3hA6cL8wE2uT5yB7nZ9r';
// 油脂纠偏接口统一走线上 nginx（https://ccyy.jsltpct.cn/gyyz → shltyy 网关），本地开发和生产完全一致，不再分环境。
// nginx 已全局配好 CORS（Access-Control-Allow-Origin * + OPTIONS 直接 204），所以本地 localhost 直连线上也不会被跨域拦截。
// 注意：签名用的路径永远是服务端视角的短路径 /api/v1/...（网关剥前缀），与此处的请求地址无关。
const OIL_API_BASE = 'https://ccyy.jsltpct.cn';

/**
 * 生成 v1 外部接口签名头（external-query 签名校验，见《external-query 外部接口签名校验使用文档》）
 * 签名串：METHOD(大写) + "\n" + REQUEST_PATH(不含 query) + "\n" + SORTED_QUERY(key 升序，k=encodeURIComponent(v)) + "\n" + TIMESTAMP(Unix 秒级)
 * X-Signature = HMAC-SHA256(signString, secret)，小写 hex
 * 注意：签名用的 REQUEST_PATH 必须是【服务端实际看到的路径】。网关会剥掉 /shltyy/gyyz 前缀转发，
 *      服务端 request.getRequestURI() 拿到的是 /api/v1/xxx（已用服务端日志中的期望签名验证），
 *      所以这里签名传短路径，而实际请求 URL 仍是完整地址，两者互不影响。
 * @param {string} method HTTP 方法（GET/POST...）
 * @param {string} path 签名用的请求路径（短路径，如 /api/v1/car_raise_plans）
 * @param {Object} params query 参数对象（会同时用于排序签名和实际请求串，保证两端一致）
 * @param {string} openid 公众号 openid
 * @returns {{ headers: Object, sortedQuery: string }} 请求头 { X-Timestamp, X-Open-Id, X-Signature } 与排序后的 query 串
 */
function buildOilSignedHeaders(method, path, params, openid) {
  const timestamp = Math.floor(Date.now() / 1000).toString();
  const sortedQuery = Object.keys(params || {})
    .sort()
    .map((k) => `${k}=${encodeURIComponent(String(params[k]))}`)
    .join('&');
  const signString = `${method.toUpperCase()}\n${path}\n${sortedQuery}\n${timestamp}`;
  const signature = CryptoJS.HmacSHA256(signString, OIL_API_SECRET).toString(CryptoJS.enc.Hex);
  return {
    headers: {
      'X-Timestamp': timestamp,
      'X-Open-Id': openid,
      'X-Signature': signature,
    },
    sortedQuery,
  };
}

export function fetch(url, params) {
  return new Promise((resolve, reject) => {
    axios.defaults.headers['Content-Type'] = 'application/json';
    //axios.defaults.headers.common['X-AUTH-TOKEN'] = sessionStorage.site_current_token
    axios
      .post(url, params)
      .then((response) => {
        resolve(JSON.stringify(response.data));
      })
      .catch((error) => {
        var errorStatus = error.response.status;
        if (errorStatus == 401) {
          sessionStorage.site_current_token = '';
          location.reload();
        } else {
          Dialog.alert({
            message: errorStatus + '错误，请稍后再试',
          }).then(() => {
            console.log(error);
          });
        }
        reject(error);
      });
  });
}

export function fetchBlob(url, params) {
  return new Promise((resolve, reject) => {
    // 创建独立配置（避免污染全局设置）
    const config = {
      headers: {
        'Content-Type': 'application/json',
        // 'X-AUTH-TOKEN': sessionStorage.site_current_token || ''
      },
      responseType: 'blob', // 正确设置响应类型
    };

    axios
      .post(url, params, config) // 将配置传入请求
      .then((response) => {
        // 直接返回Blob对象（无需JSON处理）
        resolve(response.data);
      })
      .catch((error) => {
        // 统一错误处理
        if (error.response) {
          const { status } = error.response;

          if (status === 401) {
            sessionStorage.removeItem('site_current_token');
            location.reload(); // 跳转登录
          } else {
            Dialog.alert({
              message: `${status}错误，请稍后再试`,
            });
          }
        } else {
          // 网络错误或请求未发出
          Dialog.alert({
            message: '网络错误，请检查连接',
          });
        }
        reject(error);
      });
  });
}

export function getFetch(url) {
  return new Promise((resolve, reject) => {
    axios.defaults.headers['Content-Type'] = 'application/json';
    //axios.defaults.headers.common['X-AUTH-TOKEN'] = sessionStorage.site_current_token
    axios
      .get(url)
      .then((response) => {
        resolve(JSON.stringify(response.data));
      })
      .catch((error) => {
        // 网络错误/跨域被拒时 error.response 可能为空，需兜底避免二次异常
        const errorStatus = error && error.response ? error.response.status : 0;
        if (errorStatus == 401) {
          sessionStorage.site_current_token = '';
          location.reload();
        } else if (errorStatus) {
          Dialog.alert({
            message: errorStatus + '错误，请稍后再试',
          }).then(() => {
            console.log(error);
          });
        } else {
          console.warn('[getFetch] 请求未送达(网络/跨域):', url, error);
        }
        reject(error);
      });
  });
}

export function formFetch(url, params) {
  return new Promise((resolve, reject) => {
    axios.defaults.headers['Content-Type'] = 'application/json';
    //axios.defaults.headers.common['X-AUTH-TOKEN'] = sessionStorage.site_current_token
    axios
      .post(url, params)
      .then((response) => {
        resolve(JSON.stringify(response.data));
      })
      .catch((error) => {
        console.log(error);
        var errorStatus = error.response.status;
        if (errorStatus == 401) {
          sessionStorage.site_current_token = '';
          location.reload();
        } else {
          Dialog.alert({
            message: errorStatus + '错误，请稍后再试',
          }).then(() => {
            console.log(error);
          });
        }
        reject(error);
      });
  });
}

export function formFileFetch(url, params) {
  return new Promise((resolve, reject) => {
    // 创建独立配置（避免污染全局设置）
    const config = {
      headers: {
        // 'Content-Type': 'multipart/form-data',
        // 'X-AUTH-TOKEN': sessionStorage.site_current_token || ''
      },
    };

    axios
      .post(url, params, config) // 将配置传入请求
      .then((response) => {
        // 直接返回Blob对象（无需JSON处理）
        resolve(response.data);
      })
      .catch((error) => {
        // 统一错误处理
        if (error.response) {
          const { status } = error.response;

          if (status === 401) {
            sessionStorage.removeItem('site_current_token');
            location.reload(); // 跳转登录
          } else {
            Dialog.alert({
              message: `${status}错误，请稍后再试`,
            });
          }
        } else {
          // 网络错误或请求未发出
          Dialog.alert({
            message: '网络错误，请检查连接',
          });
        }
        reject(error);
      });
  });
}

export default {
  //获取token 接口调用
  getServiceToken() {
    var data = JSON.stringify({
      query: '',
      variables: {},
    });
    const username = 'test';
    const password = '123456';
    return fetch('/ltxt/rest/tokens?username=' + username + '&password=' + password, data);
  },
  //根据code 获取用户信息
  getUserInfo(code) {
    return getFetch('/ltxt/rest/ltxtCcpdYhxxController/getbycode/' + code);
  },
  getUserInfoByopenid(openid) {
    return getFetch('/ltxt/rest/ltxtCcpdYhxxController/getbyopid/' + openid);
  },
  //查询绑定的车辆信息
  getVehicleInfo(openid) {
    return getFetch('/ltxt/rest/ltxtCcpdYhclController/getbyopenid/' + openid);
  },
  //绑定车辆
  bindVehicle(openid, chetouhao, cheguahao) {
    var data = JSON.stringify({
      openid: openid,
      chetouhao: chetouhao,
      cheguahao: cheguahao,
    });
    return fetch('/ltxt/rest/ltxtCcpdYhclController', data);
  },
  //解绑车辆
  updateBindVehicle(openid, chetouhao, cheguahao) {
    var data = JSON.stringify({
      openid: openid,
      chetouhao: chetouhao,
      cheguahao: cheguahao,
    });
    return fetch('/ltxt/rest/ltxtCcpdYhclController/updatebyopenid', data);
  },
  addUserInfo(openid, username, mobile) {
    var data = JSON.stringify({
      openid: openid,
      name: username,
      phone: mobile,
    });
    return fetch('/ltxt/rest/ltxtCcpdYhxxController', data);
  },
  //绑定手机号码，姓名
  bindUserInfo(openid, username, mobile) {
    var data = JSON.stringify({
      openid: openid,
      name: username,
      phone: mobile,
    });
    return fetch('/ltxt/rest/ltxtCcpdYhxxController/update', data);
  },
  //模糊查询车头号
  searchChetou(search) {
    return getFetch('/ltxt/rest/ltxtCcpdCtxxController/listbyhao/' + search);
  },
  //模糊查询车尾号
  searchChegua(search) {
    return getFetch('/ltxt/rest/ltxtCcpdCgxxController/listbyhao/' + search);
  },
  //判断绑定状态
  getBindVehicleState(openid) {
    return getFetch('/ltxt/rest/ltxtCcpdYhxxController/getstate/' + openid);
  },
  //查询可用预约清单
  getYuyueList(openid) {
    //listbyopenid/{openid}
    return getFetch('/ltxt/rest/viewLtpdThtzdController/getfhtzd/' + openid);
  },
  getYuyueXhList(openid) {
    //listbyopenid/{openid}
    return getFetch('/ltxt/rest/viewLtpdThtzdController/getxhtzd/' + openid);
  },
  //查询可用时间
  getPdInfo(outportStr) {
    return getFetch('/ltxt/rest/viewLtpdPdxxController/getpdxx/' + outportStr);
  },
  //添加预约
  addYuyue(openid, pdid, billnos, yuzuoyesl, xhdh, qfh) {
    var data = JSON.stringify({
      openid: openid,
      pdid: pdid,
      pdsjd: billnos,
      txhlb: '',
      yuzuoyesl: yuzuoyesl,
      xhdh: xhdh, // 卸货单号
      qfh: qfh, // 铅封号
    });
    return fetch('/ltxt/rest/ltxtCcpdYyzbController', data);
  },
  getOrderList(openid, page) {
    return getFetch('/ltxt/rest/ltxtCcpdYyzbController/list/' + openid + '/' + page);
  },
  getNowOrderList(openid) {
    return getFetch('/ltxt/rest/ltxtCcpdYyzbController/listalluse/' + openid);
  },
  getOrderDetail(id) {
    return getFetch('/ltxt/rest/ltxtCcpdYyzbController/getbyid/' + id);
  },
  getxybyopenid(openid) {
    return getFetch('/ltxt/rest/ltpdCcpdYyaqgzController/getbyopenid/' + openid);
  },
  getxyconfirmbyopenid(openid, type) {
    return getFetch('/ltxt/rest/ltpdCcpdXycomfirmController/getbyopenid/' + openid + '/' + type);
  },
  addxybyopenid(openid) {
    var data = JSON.stringify({
      openid: openid,
    });
    return fetch('/ltxt/rest/ltpdCcpdYyaqgzController', data);
  },
  confirmxybyopenid(openid, type) {
    var data = JSON.stringify({
      openid: openid,
      type: type,
    });
    return fetch('/ltxt/rest/ltpdCcpdXycomfirmController', data);
  },
  postupdzyd(data) {
    return formFetch('/ltxt/rest/ltxtCcpdYyzbController/postupdzyd/', data);
  },
  postupdzydnew(data) {
    return formFetch('/ltxt/rest/ltxtCcpdYyzbController/postupdzydnew/', data);
  },

  getSwipeList() {
    return getFetch('/ltxt/rest/ltxtCcpdSyimglistController/listall/');
  },

  getUploadTravelState(openid) {
    return getFetch('/ltxt/rest/ltxtCcpdXckbaController/listbyopenidky/' + openid);
  },
  postTravel(data) {
    return formFetch('/ltxt/rest/ltxtCcpdXckbaController/postupxck/', data);
  },
  postTravelInfo(data) {
    return fetch('/ltxt/rest/ltxtCcpdXckbaController/', data);
  },
  submitdzyd(data) {
    return fetch('/ltxt/rest/ltxtCcpdYyzbController/submitdzyd/', data);
  },

  //new
  getDriverByOpenid(openid) {
    return getFetch('/ltxt/rest/ltxtCcpdJsyxxController/listbyopenid/' + openid);
  },
  //驾驶员
  beianJsz(data) {
    return fetch('/ltxt/rest/ltxtCcpdJsyxxController', data);
  },
  //获取驾驶员备案详情
  getDriverBeianDetail(id) {
    return getFetch('/ltxt/rest/ltxtCcpdJsyxxController/getbyid/' + id);
  },
  //更新驾驶员备案
  updateBeianJsz(data) {
    return fetch('/ltxt/rest/ltxtCcpdJsyxxController/update/', data);
  },
  //提交驾驶员信息审核
  submitBeianJsy(data) {
    return fetch('/ltxt/rest/ltxtCcpdJsyxxController/submitjsyxx/', data);
  },
  //删除驾驶员备案
  // deleteBeianJsy(data) {
  //   return formFetch('/ltxt/rest/ltxtCcpdJsyxxController/delete/', data);
  // },
  //停用驾驶员备案
  // stopBeianJsy(data) {
  //   return fetch('/ltxt/rest/ltxtCcpdJsyxxController/stopjsyxx/', data);
  // },
  //上传驾驶证图片
  uploadJszFront(data) {
    return formFetch('/ltxt/rest/ltxtCcpdJsyxxController/postupjszimg', data);
  },
  //上传驾驶证反面图片
  uploadJszFy(data) {
    return formFetch('/ltxt/rest/ltxtCcpdJsyxxController/postupjsyfmimg', data);
  },
  //上传从业资格证图片
  uploadCyzgz(data) {
    return formFetch('/ltxt/rest/ltxtCcpdJsyxxController/postupcyzgimg', data);
  },
  //上传从业资格证反面图片
  uploadCyzgzFm(data) {
    return formFetch('/ltxt/rest/ltxtCcpdJsyxxController/postupcyzgfmimg', data);
  },
  //押运员
  //备案押运员
  beianYsy(data) {
    return fetch('/ltxt/rest/ltxtCcpdYyyxxController', data);
  },
  //更新押运员备案
  updateBeianYsy(data) {
    return fetch('/ltxt/rest/ltxtCcpdYyyxxController/update/', data);
  },
  //停用
  // stopBeianYsy(data)
  // {
  //   return fetch('/ltxt/rest/ltxtCcpdYyyxxController/stopyyyxx/', data);
  // },
  //删除押运员
  // deleteBeianYsy(data) {
  //   return formFetch('/ltxt/rest/ltxtCcpdYyyxxController/delete/', data);
  // },
  //获取押运员信息列表
  getEscortByOpenid(openid) {
    return getFetch('/ltxt/rest/ltxtCcpdYyyxxController/listbyopenid/' + openid);
  },
  //获取驾押运员备案详情
  getEscortBeianDetail(id) {
    return getFetch('/ltxt/rest/ltxtCcpdYyyxxController/getbyid/' + id);
  },
  //提交押运员信息审核
  submitBeianYsy(data) {
    return fetch('/ltxt/rest/ltxtCcpdYyyxxController/submityyyxx/', data);
  },

  //获取车头信息
  getChetouList(openid) {
    //return getFetch('/ltxt/rest/ltxtCcpdCtxxController/listbyopenid/' + openid)
    return getFetch('/ltxt/rest/ltxtCcpdCtxxController/getbyopenid/' + openid);
  },
  //获取车挂信息
  getCheguaList(openid) {
    return getFetch('/ltxt/rest/ltxtCcpdCgxxController/listbyopenid/' + openid);
  },
  //获取品种信息
  getPzList() {
    //return getFetch('/ltxt/rest/viewLtpdErppinzhongController/listall')
    return getFetch('/ltxt/rest/ltxtJcPzxxController/listall');
  },
  //上传道路运输证正本正面图片
  uploadDlys(data) {
    return formFetch('/ltxt/rest/ltxtCcpdCtxxController/postupdlyszzbzm', data);
  },
  //上传道路运输 代理
  uploadDcl(type, data) {
    if (type == 'dcl_zm') {
      return formFetch('/ltxt/rest/ltxtCcpdCtxxController/postupdlyszdlzm', data);
    } else if (type == 'dcl_fm') {
      return formFetch('/ltxt/rest/ltxtCcpdCtxxController/postupdlyszdlfm', data);
    }
  },
  //上传道路运输证正本正面图片
  uploadCgDlys(data) {
    return formFetch('/ltxt/rest/ltxtCcpdCgxxController/postupdlyszzbzm', data);
  },
  //上传道路运输 代理
  uploadCgDcl(type, data) {
    if (type == 'dcl_zm') {
      return formFetch('/ltxt/rest/ltxtCcpdCgxxController/postupdlyszdlzm', data);
    } else if (type == 'dcl_fm') {
      return formFetch('/ltxt/rest/ltxtCcpdCgxxController/postupdlyszdlfm', data);
    }
  },
  //备案车头
  beianChetou(data) {
    return fetch('/ltxt/rest/ltxtCcpdCtxxController', data);
  },
  updateBeianChetou(data) {
    return fetch('/ltxt/rest/ltxtCcpdCtxxController/update/', data);
  },
  //备案车头详情
  getChetouBeianDetail(openid) {
    //return getFetch('/ltxt/rest/ltxtCcpdCtxxController/getbyid/' + id);
    return getFetch('/ltxt/rest/ltxtCcpdCtxxController/getbyopenid/' + openid);
  },
  //
  getChetouBeianDetailById(id) {
    return getFetch('/ltxt/rest/ltxtCcpdCtxxController/getbyid/' + id);
    // return getFetch('/ltxt/rest/ltxtCcpdCtxxController/getbyopenid/' + openid);
  },
  //删除备案车头信息
  deleteBeianChetou(data) {
    return formFetch('/ltxt/rest/ltxtCcpdCtxxController/delete/', data);
  },
  stopBeianChetou(data) {
    return fetch('/ltxt/rest/ltxtCcpdCtxxController/stopctxx/', data);
  },
  submitBeianChetou(data) {
    return fetch('/ltxt/rest/ltxtCcpdCtxxController/submitctxx/', data);
  },
  //上传罐体图片
  uploadGtImage(data) {
    return fetch('/ltxt/rest/ltxtCcpdCgxxController/postupgjimg/', data);
  },
  //备案车挂
  beianChegua(data) {
    return fetch('/ltxt/rest/ltxtCcpdCgxxController/', data);
  },
  //备案车挂信息
  deleteBeianChegua(data) {
    return formFetch('/ltxt/rest/ltxtCcpdCgxxController/delete/', data);
  },
  stopBeianChegua(data) {
    return fetch('/ltxt/rest/ltxtCcpdCgxxController/stopcgxx/', data);
  },
  submitBeianChegua(data) {
    return fetch('/ltxt/rest/ltxtCcpdCgxxController/submitcgxx/', data);
  },
  //获取车挂信息
  getCheguaBeianDetail(id) {
    return getFetch('/ltxt/rest/ltxtCcpdCgxxController/getbyid/' + id);
  },
  updateBeianChegua(data) {
    return fetch('/ltxt/rest/ltxtCcpdCgxxController/update/', data);
  },
  //上传行驶证
  //上传行驶证
  uploadCheguaXsz(type, data) {
    switch (type) {
      case 'xsz_zb_zm':
        return formFetch('/ltxt/rest/ltxtCcpdCgxxController/postupxszzbzm', data);
      case 'xsz_zb_fm':
        return formFetch('/ltxt/rest/ltxtCcpdCgxxController/postupxszzbfm', data);
      case 'xsz_fb_zm':
        return formFetch('/ltxt/rest/ltxtCcpdCgxxController/postupxszfbzm', data);
      case 'xsz_fb_fm':
        return formFetch('/ltxt/rest/ltxtCcpdCgxxController/postupxszfbfm', data);
    }
  },
  uploadXsz(type, data) {
    switch (type) {
      case 'xsz_zb_zm':
        return formFetch('/ltxt/rest/ltxtCcpdCtxxController/postupxszzbzm', data);
      case 'xsz_zb_fm':
        return formFetch('/ltxt/rest/ltxtCcpdCtxxController/postupxszzbfm', data);
      case 'xsz_fb_zm':
        return formFetch('/ltxt/rest/ltxtCcpdCtxxController/postupxszfbzm', data);
      case 'xsz_fb_fm':
        return formFetch('/ltxt/rest/ltxtCcpdCtxxController/postupxszfbfm', data);
    }
  },
  isgeneralgood(scope) {
    return getFetch('/ltxt/rest/ltxtJcPzxxController/isgeneralgood/' + scope);
  },
  getUploadHealthCode(openid) {
    return getFetch('/ltxt/rest/ltxtCcpdSyssetController/getyysfschspic/' + openid);
  },
  getyyzbhsbg(id) {
    return getFetch('/ltxt/rest/ltxtCcpdYyzbHsbgController/getyyzbhsbg/' + id);
  },
  uploadHsResult(data) {
    return formFetch('/ltxt/rest/ltxtCcpdYyzbHsbgController/update/', data);
  },
  uploadPicHs(type, data) {
    switch (type) {
      case 'jsy':
        return formFetch('/ltxt/rest/ltxtCcpdYyzbHsbgController/postupjsyhsimg', data);
      case 'yyy':
        return formFetch('/ltxt/rest/ltxtCcpdYyzbHsbgController/postupyyyhsimg', data);
    }
  },
  postxhbd(data) {
    return formFetch('/ltxt/rest/ltxtCcpdYyzbController/postupxhbd/', data);
  },
  submitxhbdxx(data) {
    return formFetch('/ltxt/rest/ltxtCcpdYyzbController/submitxhbdxx/', data);
  },
  getSysInfo(openid) {
    return getFetch('/ltxt/rest/ltxtCcpdSyssetController/getsysinfo/' + openid);
  },
  getsysBcInfo(type) {
    return getFetch('/ltxt/rest/ltxtCcpdSysbcController/getsysbcinfo/' + type);
  },
  gettxhtzdnew(data) {
    return formFetch('/ltxt/rest/viewLtpdThtzdController/gettxhtzdnew/', data);
  },
  getpdxxnew(data) {
    return formFetch('/ltxt/rest/viewLtpdPdxxController/getpdxxnew/', data);
  },
  getkyyyrq(data) {
    return formFetch('/ltxt/rest/viewLtpdPdxxController/getkyyyrq/', data);
  },
  poststopyy(data) {
    return fetch('/ltxt/rest/ltxtCcpdYyzbController/poststopyy/', data);
  },
  postadjustyy(data) {
    return fetch('/ltxt/rest/ltxtCcpdYyzbController/postadjustyy/', data);
  },
  getTypeList(typeGroupName) {
    return fetch('/ltxt/rest/systemController.do?typeListJson&typeGroupName=' + typeGroupName);
  },

  // 生成协议PDF
  createAgreementPdf(data) {
    // return fetch('/ltxt/rest/ltxtCcCczxfwxyController/qianzi', data);
    return fetchBlob('/ltxt/rest/ltxtCcCczxfwxyController/qianzi', data);
  },

  // 上传协议
  uploadAgreement(data) {
    return formFileFetch('/ltxt/rest/ltxtCcCczxfwxyController/upLoadFile', data);
  },

  // 添加协议
  addAgreement(data) {
    return fetch('/ltxt/rest/ltxtCcCczxfwxyController/doAdd', data);
  },

  // 添加蒸洗用户信息
  addSteamUserInfo(data) {
    // eslint-disable-next-line no-undef
    return fetch('/ltxt/rest/ltxtSteamUserInfoController/addSteamUserInfo', data);
  },

  // 更新蒸洗用户信息
  updateSteamUserInfo(data) {
    // eslint-disable-next-line no-undef
    return fetch('/ltxt/rest/ltxtSteamUserInfoController/updateSteamUserInfo', data);
  },
  isNewUserAPI(openid) {
    return getFetch(`/ltxt/rest/ltxtCcpdYhxxController/judgeNewUser?openid=${openid}`);
  },

  // 普危分流：根据 openid、提卸货类别和车牌判断走对话预约还是旧预约
  // 首页进来就调用，传参 openid；车头号 / 车挂号未拿到时按要求显式传空字符串，
  // 而不是省略字段。后端统一按"openid + 车号"解析（见 dhyy-api(3).md §3.1）。
  // txhlb 可选：首页调用时不传（仅按 openid+车牌判定整体普货/危货），
  // 提卸货入口调用时再传（按业务类型判定本次走对话还是旧流程）。
  judgePhWh(openid, txhlb = '', chetouhao = '', cheguahao = '') {
    const token = process.env.VUE_APP_DHYY_TOKEN || '';
    const body = { openid, txhlb, chetouhao, cheguahao };
    const data = JSON.stringify(body);
    return axios.post('/ltxt/rest/dhyy/judgePhWh', data, {
      headers: {
        'Content-Type': 'application/json',
        'dhyytoken': token,
        'spytoken': 'fs79XXfHlg3itgF0aFF5sm3Wb7cK',
      }
    }).then((response) => JSON.stringify(response.data));
  },
  // ERP 查计划（参考 erp-process-ocr-frontend-api.md §1.2.2）
  // POST /rest/dhyy/getJhByChe
  // Body: { chetouhao, cheguahao(null 或实际车挂), txhlb }
  getJhByChe(chetouhao, cheguahao, txhlb) {
    const token = process.env.VUE_APP_DHYY_TOKEN || '';
    const data = JSON.stringify({ chetouhao, cheguahao, txhlb });
    return axios.post('/ltxt/rest/dhyy/getJhByChe', data, {
      headers: {
        'Content-Type': 'application/json',
        'dhyytoken': token,
        'spytoken': 'fs79XXfHlg3itgF0aFF5sm3Wb7cK',
      }
    }).then((response) => JSON.stringify(response.data));
  },

  // 卸货订单的客户是否是马钢/纳斯德
  ismaigang(data) {
    return formFetch(`/ltxt/rest/ltxtCcpdYyzbController/ismaigang`, data);
  },

  // 获取微信JSAPI签名（用于开放标签）- URL拼接参数
  // 注意：iOS 传入的 url 已经是未 encode 的，安卓传入的 url 已经是 encode 过的
  getWxJsapiSignature(url) {
    // 判断是否是开发环境（localhost 或 127.0.0.1）
    const isDev = window.location.hostname === 'localhost' ||
                  window.location.hostname === '127.0.0.1';

    // 判断 url 是否已经被 encode（通过检查是否包含 %）
    const isEncoded = url.includes('%');
    const finalUrl = isEncoded ? url : encodeURIComponent(url);

    if (isDev) {
      // 开发环境使用代理
      return getFetch(`/ccyy/jssdk/getToken?url=${finalUrl}`);
    } else {
      // 生产环境使用完整 HTTPS URL（Nginx 只代理 HTTPS）
      return getFetch(`https://ccyy.jsltpct.cn/ccyy/jssdk/getToken?url=${finalUrl}`);
    }
  },

  // 【纠偏】直查丽天车队（油脂/小程序）计划（v1 外部接口，external-query 签名校验）：
  //   签名串 = METHOD + "\n" + PATH(服务端视角短路径，网关剥掉 /shltyy/gyyz 前缀) + "\n" + SORTED_QUERY(key 升序) + "\n" + TIMESTAMP(秒级)，
  //   HMAC-SHA256(SECRET) 小写 hex；请求头 X-Timestamp / X-Open-Id / X-Signature。
  //   见《external-query 外部接口签名校验使用文档》。签名与实际发送的 query 串由同一参数对象生成，保证一致。
  checkOilRaisePlan(openid, truckHeadNo) {
    const path = '/api/v1/car_raise_plans';
    const params = {
      truckHeadNo,
      auditStatus: 1,
      isDisabled: 0,
      delFlag: 0,
      pageNum: 1,
      pageSize: 999,
    };
    const { headers, sortedQuery } = buildOilSignedHeaders('GET', path, params, openid);
    return axios.get(`${OIL_API_BASE}/gyyz/api/v1/car_raise_plans?${sortedQuery}`, {
      headers,
      timeout: 15000,
    }).then((response) => JSON.stringify(response.data));
  },
  checkOilUnloadPlan(openid, carNumber) {
    const path = '/api/v1/car_unload_plans';
    const params = {
      carNumber,
      auditStatus: 1,
      isDisabled: 0,
      delFlag: 0,
      pageNum: 1,
      pageSize: 999,
    };
    const { headers, sortedQuery } = buildOilSignedHeaders('GET', path, params, openid);
    return axios.get(`${OIL_API_BASE}/gyyz/api/v1/car_unload_plans?${sortedQuery}`, {
      headers,
      timeout: 15000,
    }).then((response) => JSON.stringify(response.data));
  },
};
